import React from "react";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";
import { mousedrag, closeSelec } from "../../Pages/multiCompSelect";
import { EditorScrollbarStatus } from "./index";

export const EditorMainCanvasSection = ({ children }) => {
  const {
    openTimeLine,
    playPauseRef,
    showSelection,
    Xstart,
    Ystart,
    setMultiSelect,
    tempLayer,
    multiSelect,
    isDragged,
    setMultiSelectedComps,
    canvasScrollToggle,
    canvasDimension,
    canvasScrollHeight,
    handleDrop,
    handleDragOver,
    setToggleSelected,
    handleClickOnCanvas,
    sendSelectedComponent,
    setVisibility,
    setIsEditorOn,
    clearFroalaTextSelection,
    setLayerCompData,
    contextMenuRef,
  } = useEditorMainPageContext();

  const hasCanvasDimensions =
    Number(canvasDimension?.width) > 0 && Number(canvasDimension?.height) > 0;

  if (!hasCanvasDimensions) {
    return (
      <div
        id="mainCanvasContainer"
        className="canvasUnset canvasCol-dup canvasCol mt-0"
        style={{ backgroundColor: "#eff4f7" }}
      ></div>
    );
  }

  return (
    <div
      id={"mainCanvasContainer"}
      style={{
        height: `${openTimeLine ? "50vh" : ""}`,
        backgroundColor: "#eff4f7",
      }}
      onMouseDown={(e) => {
        const clickedExistingComponent =
          typeof e.target?.closest === "function" &&
          e.target.closest(".div-dragresize-parent");

        if (clickedExistingComponent) return;

        clearFroalaTextSelection(true);
      }}
      onMouseMove={(e) => {
        !isDragged.mouseDown &&
          playPauseRef.current.animationCompleted &&
          mousedrag(
            e,
            tempLayer,
            showSelection,
            Xstart,
            Ystart,
            setMultiSelect,
            setMultiSelectedComps,
            multiSelect,
          );
      }}
      onMouseUp={(e) => {
        const selectionDiv = document.getElementById("drawSelectionDiv");
        const isMarqueeSelectionActive =
          selectionDiv &&
          ((parseFloat(selectionDiv.style.width) || 0) > 0 ||
            (parseFloat(selectionDiv.style.height) || 0) > 0);
        if (isMarqueeSelectionActive) {
          e.preventDefault();
        }
        playPauseRef.current.animationCompleted && closeSelec(showSelection);
      }}
      className={
        `${canvasScrollToggle.height < 45
          ? "canvasUnset canvasCol-dup canvasCol mt-0"
          : "canvasScroll canvasCol canvasCol-Expand mt-0 "
        }` +
        `${canvasDimension?.width > 700 ? "myCanvas" : " "} ` +
        `${canvasScrollToggle.width < 780 ? " Canvas-hide-scroll" : "Canvas-X-scroll"}`
      }
    >
      <div
        id={"drawSelectionDiv"}
        style={{
          width: multiSelect.width + "px",
          height: multiSelect.height + "px",
          left: multiSelect.left + "px",
          top: multiSelect.top + "px",
          position: "absolute",
          background: "rgba(0, 0, 0, 0.7)",
          zIndex: 100,
          opacity: 0.2,
        }}
        onMouseMove={(e) => {
          !isDragged.mouseDown &&
            playPauseRef.current.animationCompleted &&
            mousedrag(
              e,
              tempLayer,
              showSelection,
              Xstart,
              Ystart,
              setMultiSelect,
              setMultiSelectedComps,
            );
        }}
      ></div>
      <div
        style={{
          height: canvasScrollHeight,
          backgroundColor: "#eff4f7",
        }}
        className={
          canvasDimension?.scale > 1 && canvasDimension.height > 400
            ? "custonScrollBar showScrollforEditor"
            : canvasDimension?.scale > 1 && canvasDimension?.width > 300
              ? "custonScrollBar showhorizontalScroll"
              : canvasDimension?.width > 700 && !(canvasDimension?.scale < 1)
                ? "dontshowscroll2"
                : "dontshowscroll"
        }
      >
        <EditorScrollbarStatus />
        <div
          id={"canvas-page"}
          ref={contextMenuRef}
          className="dragContentCanvas centerPanel"
          style={{
            width: canvasDimension.width + "px",
            height: canvasDimension.height + "px",
            transformOrigin: "0 0",
            display: "block",
            transform: `scale(${canvasDimension.scale})`,
            background: `rgba(${canvasDimension.backgroundColor?.r}, ${canvasDimension.backgroundColor?.g}, ${canvasDimension.backgroundColor?.b}, ${canvasDimension.backgroundColor?.a} )`,
          }}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onClick={(e) => {
            setToggleSelected(false);
            handleClickOnCanvas("clickoncanvas");
            sendSelectedComponent(e, "default");
            setVisibility(false);
            setIsEditorOn("notClickedYet");
            clearFroalaTextSelection(true);
            if (!(new Date().getTime() - multiSelect.timestamp)) {
              setMultiSelectedComps([]);
              setLayerCompData((prevData) =>
                prevData.map((comp) => ({
                  ...comp,
                  multiSelected: false,
                })),
              );
            }
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};



